import { useEffect, useState } from 'react';
import './supAccount.css';
import { getSupportUser } from '../../api/supportAPI';

export default function SupAccount() {
    const [userData, setUserData] = useState(null);

    useEffect(() => {
        const getUserDetails = async () => {
            const data = await getSupportUser();
            setUserData(data.data);
        };
        getUserDetails();
    }, []);

    return (
        <div style={{ minHeight: '400px' }}>
            <div className='supAccContainer'>
                <div className='supAccFields'>
                    <h4>Name: </h4>
                    <span>{userData?.name ?? 'N/A'}</span>
                </div>
                <div className='supAccFields'>
                    <h4>Email: </h4>
                    <span>{userData?.emailId ?? 'N/A'}</span>
                </div>
                <div className='supAccFields'>
                    <h4>Phone Number: </h4>
                    <span>{userData?.phoneNumber ?? 'N/A'}</span>
                </div>
                <div className='supAccFields'>
                    <h4>Role: </h4>
                    <span>{userData?.access ?? 'N/A'}</span>
                </div>
            </div>
        </div>
    );
}
